import Axios from '@/assets/js/AxiosPlugin'

// 用户信息
export const getUserInfo = params => { return Axios.post('/api/Home/User/getUserInfo', params) }
// 用户积分
export const getAvailable = params => { return Axios.post('/api/Home/Points/getAvailable', params) }



// WEBPACK FOOTER //
// ./src/views/mobile/MemberCenter/apis/index.js